import React from 'react';
import { Result, Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

const Error404 = () => (
  <Result
    status="error"
    title={404}
    subTitle={<FormattedMessage defaultMessage="This page doesn't exist" />}
    extra={[
      <Link to="/" key="home">
        <Button type="primary">
          <FormattedMessage defaultMessage="Home page" />
        </Button>
      </Link>,
      <Link to={-1} key="back">
        <Button>
          <FormattedMessage defaultMessage="Back" />
        </Button>
      </Link>,
    ]}
  />
);

export default Error404;
